export default __webpack_public_path__ + "static/media/hand_with_dollar_sign.5d77f4bf.png";